import { AMPLITUDE_ENV } from 'Settings';
import {
  AMPLITUDE_API_KEYS,
  AMPLITUDE_EVENT_LABELS,
} from '../../settings/amplitude';

import amplitude from 'amplitude-js';

export const initializeAmplitude = (app, activeUser) => {
  const apiKey = AMPLITUDE_API_KEYS[app][AMPLITUDE_ENV];
  if (!apiKey) return null;
  if (!activeUser) {
    amplitude.getInstance(app).init(apiKey);
  } else {
    amplitude.getInstance(app).init(apiKey, activeUser.id);
    amplitude.getInstance(app).setUserProperties({
      'Product Flavor': 'Tinybop Schools',
      'Institution ID': activeUser.roles[0][0],
      'User Roles': activeUser.roles[0][1],
    });
  }
  return amplitude.getInstance(app);
};

export const setUserId = (app, username) => {
  amplitude.getInstance(app).setUserId(username);
};

export const setUserProperties = (app, properties) => {
  amplitude.getInstance(app).setUserProperties(properties);
};

export const setGameVersionNumber = (app, version) => {
  amplitude.getInstance(app).setVersionName(version);
};

export const logGameEvent = (app, data) => {
  const properties = {
    ...data.properties,
    'Topic Name': 'open play',
  };
  amplitude.getInstance(app).logEvent(data.name, properties);
};

export const logWebEvent = (name, properties) => {
  amplitude.getInstance('web-client').logEvent(name, properties);
};

export const logGameSettingsChange = (app, data) => {
  const labels = AMPLITUDE_EVENT_LABELS[app][data.name];
  const eventProperties = {
    [labels.propertyName]: mapValueForApp(labels, data.value),
    Method: 'Web Settings Bar',
    'Topic Name': 'open play',
  };
  amplitude.getInstance(app).logEvent(labels.eventName, eventProperties);
};

const mapValueForApp = (labels, value) => {
  switch (value) {
    case true:
    case false:
      return labels[value];
    default:
      return value;
  }
};
